/*
    MetricDescription.tsx -- A component for rendering a description about a Metric.
*/

import type { JSX } from 'react';

import { Button } from 'Components/Buttons/Buttons';
import { Modal } from 'Components/Modal/Modal';
import { Text } from 'Components/Text/Text';
import { ICON_CLOSE } from 'Config/Icons';
import { MetricMetadata, MetricResponse } from 'Models/ExternalIntegrations';

import styles from './Metric.module.css';

export interface MetricDescriptionProps {
    hideModal: () => void;
    metric: MetricResponse;
}

export const MetricDescription = (props: MetricDescriptionProps): JSX.Element => {
    const formatRecommendedControlMapping = (recommendedControlMapping: string): JSX.Element[] => {
        const elements = [];

        const controlFrameworks = recommendedControlMapping.split(';');

        let recommendation;
        for (let i = 0; i < controlFrameworks.length; i++) {
            recommendation = controlFrameworks[i].trim();
            elements.push(
                <li key={recommendation}>
                    <Text noStyles>{recommendation}</Text>
                </li>
            );
        }

        return elements;
    };

    return (
        <Modal open header={props.metric.metric_name}>
            <Text variant="Header4">Description:</Text>
            <Text>{MetricMetadata[props.metric.integration_name][props.metric.metric_name]!.description}</Text>
            <Text variant="Header4">Recommended Control Mapping:</Text>
            <div className={styles.metricModalText}>
                <ul>{formatRecommendedControlMapping(MetricMetadata[props.metric.integration_name][props.metric.metric_name]!.recommended_control_mapping)}</ul>
            </div>
            <div className={styles.metricModalButtons}>
                <Button variant="secondary" onClick={props.hideModal} fontAwesomeImage={ICON_CLOSE}>
                    Close
                </Button>
            </div>
        </Modal>
    );
};
